export default theme => {
  return {
    container: {
      marginTop: 20
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/Template/theme/components/selection/SetBuilder/SetBuilderFooter.js